import { ApiCore } from '../api';

const api = new ApiCore();
const KEY = 'edc_project_config';

export interface ProjectConfig {
  eproUrl?: string | number | null;
  newCrm?: string | number | null;
}

const readMap = (): Record<string, ProjectConfig> => {
  try {
    const v = sessionStorage.getItem(KEY);
    return v ? (JSON.parse(v) as Record<string, ProjectConfig>) : {};
  } catch {
    return {};
  }
};

const writeMap = (m: Record<string, ProjectConfig>) => {
  sessionStorage.setItem(KEY, JSON.stringify(m));
};

/** 写入单个项目的配置（eproUrl / newCrm），供移动端各页面读取 */
export const saveProjectConfig = (code: string, cfg: ProjectConfig) => {
  if (!code) return;
  const m = readMap();
  m[code] = { ...(m[code] || {}), ...cfg };
  writeMap(m);
};

/** 同步读取缓存中的项目配置（不触发网络请求） */
export const getProjectConfigSync = (code: string): ProjectConfig => {
  if (!code) return {};
  return readMap()[code] || {};
};

/**
 * 异步获取项目配置：优先读缓存，未命中再调 /project/projects 拉取并按 projectCode 匹配，
 * 结果回写缓存。用于工作台进入项目后透传 eproUrl / newCrm。
 */
export const fetchProjectConfig = async (code: string): Promise<ProjectConfig> => {
  if (!code) return {};
  const existing = getProjectConfigSync(code);
  const hit =
    existing &&
    (existing.eproUrl !== undefined && existing.eproUrl !== null) ||
    (existing.newCrm !== undefined && existing.newCrm !== null);
  if (hit) {
    return existing;
  }
  try {
    const res: any = await api.getProject();
    if (res && res.code === 0) {
      const list: any[] = res.data || [];
      const proj = list.find((p: any) => (p.code || p.projectCode) === code);
      if (proj) {
        const cfg: ProjectConfig = {
          eproUrl: proj.eproUrl,
          newCrm: proj.newCrm,
        };
        saveProjectConfig(code, cfg);
        return cfg;
      }
    }
  } catch {
    /* 忽略异常，返回已有缓存 */
  }
  return existing || {};
};

/** 判断是否走 PMP 新链路（eproUrl == 1） */
export const isEproPmp = (eproUrl?: string | number | null): boolean =>
  Number(eproUrl) === 1;

/** 判断是否新建受试者弹窗显示手写姓名缩写（newCrm == 1） */
export const isNewCrm = (newCrm?: string | number | null): boolean =>
  Number(newCrm) === 1;
